export default __webpack_public_path__ + "static/assets/bdf093898c6856057f59bdb718685e85.png";